import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import FileList from './FileList';
import Viewer from '../Viewer';
import CreateFlow from './CreateFlow';
import UploadHash from '../UploadHash';
import PageContentError from '../UI/PageContentError';

const FileRoute = () => {
  const match = useRouteMatch();
  const { path } = match;
  return <Switch>
    <Route exact path={path} render={(props) => <FileList {...props} />} />
    <Route path={`${path}/new`} component={UploadHash} />
    <Route path={`${path}/view/:number`} render={(props) => <Viewer {...props} type='document' />} />
    <Route exact path={`${path}/flow/:number`} component={CreateFlow} />
    <Route path={`${path}/:number`} render={(props) => <Viewer {...props} type='document' />} />
    <Route path='*' component={PageContentError} />
  </Switch>;
};

export default FileRoute;
